export default __webpack_public_path__ + "static/media/tomato.b85c3d4b.png";